import { render, staticRenderFns } from "./best-paper.vue?vue&type=template&id=d12ff8bc&scoped=true"
import script from "./best-paper.vue?vue&type=script&lang=js"
export * from "./best-paper.vue?vue&type=script&lang=js"
import style0 from "./best-paper.vue?vue&type=style&index=0&id=d12ff8bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12ff8bc",
  null
  
)

export default component.exports